<template>
  <div v-if="this.actualDerivative.mrp > 500" class="pricing-result">
    <div class="pricing-result__block">
      <div class="pricing-result__label">
        {{savingLabel}}
      </div>
      <div class="pricing-result__result pricing-result__result--blurred"></div>
    </div>
    <div class="pricing-result__block">
      <div class="pricing-result__label">
        {{rrpLabel}}
      </div>
      <div class="pricing-result__result pricing-result__result--clear">
        {{pricingCurrency}}{{mrpPrice}}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import {
  State,
  Getter,
  Action,
  Mutation,
  namespace
} from 'vuex-class';
import Derivative from '../../models/vehicle/derivative';
import IDerivative from '../../models/vehicle/interfaces/derivative.d';

const VehicleModule = namespace('vehicleModule');
const PostEnquiryModule = namespace('postEnquiryModule');

@Component
export default class PriceHintComponent extends Vue {
  @VehicleModule.Getter public currentDerivative;

  @Prop({ default: 'RRP' })
  public rrpLabel!: string;

  @Prop({ default: 'Great Price' })
  public savingLabel!: string;

  @Prop({ default: '£' })
  public pricingCurrency!: string;

  public get mrpPrice(): string {
    if (this.actualDerivative === null || this.actualDerivative.mrp === null) {
      return '0';
    }

    return Math.floor(this.actualDerivative.mrp)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Will work out whether to use the store or the prop value.
  public get actualDerivative(): IDerivative | null {
    if (this.currentDerivative !== null || typeof this.currentDerivative !== 'undefined') {
      return this.currentDerivative as Derivative;
    }
    return null;
  }
}
</script>
